import { TThunkAction } from '../../types/redux';
import { unselectFeature } from '../unselectFeature/unselectFeature';

export function closeOfferPreview(): TThunkAction {
  return dispatch => {
    dispatch(unselectFeature());
  };
}
